import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import { H5, Image } from '../../../AbstractElements';
import CountdownData from './CountdownData';
import logo from '../../../assets/images/other-images/logo-login.png';
import { APP_PATHS } from '../../../utils/appPaths';

const ComingSimple = () => {
  return (
    <Fragment>
      <div className='page-wrapper' id='pageWrapper'>
        {/* <!-- Page Body Start--> */}
        <Container fluid={true} className='p-0'>
          <div className='comingsoon'>
            <div className='comingsoon-inner text-center'>
              <Link to={APP_PATHS.dashboard}>
                <Image attrImage={{ src: `${logo}`, alt: '' }} />
              </Link>
              <H5>WE ARE COMING SOON</H5>
              <div className='countdown' id='clockdiv'>
                <CountdownData />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </Fragment>
  );
};

export default ComingSimple;
